<template>
  <div>
    <h3 class="uppercase text-2xl xs:px-3 sm:px-3 xs:leading-tight sm:leading-tight">
      GRACIAS POR TU CONTRATACIÓN
    </h3>
    <div class="separator_form"></div>
    <p class="text-center text-18 resumen_copy xs:px-5 sm:px-5 sm:text-base xs:text-base" v-if="shipping">
      {{ shipping?.plazo_instalacion || 'Procesando información...' }}.
    </p>

    <div class="heading_separator"></div>
    <div class="xs:flex xs:flex-col sm:flex sm:flex-col xs:px-6 sm:px-6">
      <p class="font-bold text-center text-xl xs:text-2xl sm:text-2xl xs:px-5 sm:px-5">
        INFORMACIÓN SOBRE TU PAQUETE
      </p>
      <p class="text-center text-18 resumen_copy xs:px-5 sm:px-5 sm:text-base xs:text-base">
        {{ shipping?.mensaje_respuesta || '' }}
      </p>

      <PackageInfo :product="product" />
      <InstallationCost 
        :product="product" 
        :payment-method="paymentMethod"
        :susc-efectivo="susc_efectivo"
      />
      <MonthlyCost 
        :product="product"
        :payment-method="paymentMethod"
        :efectivo-price="effectivoPrice"
        :flag-h-d="flagHD"
        :precio-h-d="precioHD"
      />
      <DiscountInfo 
        :product="product"
        :payment-method="paymentMethod"
        :flag-h-d="flagHD"
      />
    </div>

    <transition name="fade">
      <ModalNotificationInvalidPostalCode
        v-show="error"
        :message="error"
        @onClose="onCloseSubscriptionError"
      />
    </transition>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { mapGetters, mapState, useStore } from 'vuex';
import ModalNotificationInvalidPostalCode from '@/components/modals/ModalNotificationInvalidPostalCode.vue';
import PackageInfo from './resumen/components/PackageInfo.vue';
import InstallationCost from './resumen/components/InstallationCost.vue';
import MonthlyCost from './resumen/components/MonthlyCost.vue';
import DiscountInfo from './resumen/components/DiscountInfo.vue';
import { usePaymentCallback, getPaymentCallbackHandler } from './resumen/composables/usePaymentCallback';
import { useShippingDispatch } from './resumen/composables/useShippingDispatch';
import { useAnalytics } from './resumen/composables/useAnalytics';

export default {
  components: {
    ModalNotificationInvalidPostalCode,
    PackageInfo,
    InstallationCost,
    MonthlyCost,
    DiscountInfo
  },
  computed: {
    ...mapState({
      shipping: (state) => state.Subscription.shipping_information,
      effectivoPrice: (state) => state.Subscription.effectivo_price,
      paymentMethod: (state) => state.Subscription.payment_method,
      susc_efectivo: (state) => state.Subscription.susc_efectivo,
    }),
    ...mapGetters({
      product: 'getProductInformation',
      error: 'getError',
    }),
  },
  setup() {
    const store = useStore();
    const { processBanamexCallback } = usePaymentCallback();
    const PaymentCallbackHandler = getPaymentCallbackHandler();
    const { sendShippingInfo } = useShippingDispatch();
    const { trackPurchase } = useAnalytics();

    const flagHD = store.state.Subscription?.checkHD || false;
    const precioHD = 20;

    onMounted(async () => {
      // Detectar callback de pago de Banamex
      if (window.location.search.includes('resultIndicator')) {
        let callbackResult = null;
        if (PaymentCallbackHandler?.handleCallback) {
          callbackResult = await PaymentCallbackHandler.handleCallback();
        }

        const success = await processBanamexCallback(callbackResult);
        
        if (!success) {
          console.error('❌ Callback de Banamex falló, no se enviará shipping');
          return;
        }
        
        console.log('✅ Callback de Banamex exitoso, continuando con shipping...');
      }

      // Enviar shipping según método de pago (aplica para todos: telmex, tarjeta, paypal, efectivo)
      const metodopago = store.state.Subscription?.payment_method;
      const paymentTransaction = store.getters.getPaymentTransaction;
      sendShippingInfo(metodopago, paymentTransaction);

      // Tracking de analytics
      const product = store.state.Products?.selected || {};
      trackPurchase(product);

      // Marcar suscripción como completa
      store.commit('SET_SUBSCRIPTION_COMPLETE', true);
    });

    const onCloseSubscriptionError = () => {
      store.commit('SET_ERROR_SUBSCRIPTION', '');
    };

    return { 
      onCloseSubscriptionError, 
      flagHD, 
      precioHD 
    };
  },
};
</script>

<style scoped>
.separator_form {
  @apply m-auto mb-6;
  max-width: 520px;
}
.resumen_copy {
  @apply m-auto;
  max-width: 600px;
  line-height: 27px;
}
@media screen and (max-width: 767px) {
  .separator_form {
    width: 80%;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .resumen_grid._2 {
    grid-template-rows: auto auto 1fr;
  }
}
</style>
